import React, { useEffect, useState } from "react";
import { Modal, ModalContent, Button } from "@heroui/react";

import useModalStore from "../../store/useModalStore";
import { useGetAccount } from "../../hooks/sdkDappHooks";
import { UserInfo } from "../UserInfo";

import { ConnectWalletSection } from "./components/connect-wallet-section";
import { ProductShowcase } from "./components/product-showcase";

export default function ConnectModal() {
  const [shouldCloseOnInteractOutside, setShouldCloseOnInteractOutside] =
    useState(true);
  const { connectWalletModalOpen, setConnectWalletModalOpen } = useModalStore();

  const { address } = useGetAccount();

  useEffect(() => {
    if (address) {
      setConnectWalletModalOpen(false);
    }
  }, [address, setConnectWalletModalOpen]);

  const handleOpenConnectModal = () => {
    setConnectWalletModalOpen(true);
  };

  return (
    <div className="w-full flex justify-end">
      {address ? (
        <UserInfo />
      ) : (
        <Button
          className="bg-primary text-white"
          onPress={handleOpenConnectModal}
          radius="full"
          size="sm"
        >
          Connect Wallet
        </Button>
      )}

      <Modal
        isOpen={connectWalletModalOpen}
        onOpenChange={(isOpen) => setConnectWalletModalOpen(isOpen)}
        isDismissable={shouldCloseOnInteractOutside}
        shouldCloseOnInteractOutside={() => shouldCloseOnInteractOutside}
        classNames={{
          base: "bg-black rounded-xl overflow-hidden shadow-xl",
          backdrop: "bg-black/90 backdrop-blur-md",
        }}
        motionProps={{
          variants: {
            enter: {
              opacity: 1,
              scale: 1,
              transition: { duration: 0.3, ease: [0.22, 1, 0.36, 1] },
            },
            exit: {
              opacity: 0,
              scale: 0.98,
              transition: { duration: 0.2, ease: [0.22, 1, 0.36, 1] },
            },
          },
        }}
      >
        <ModalContent className="md:max-w-[800px] max-h-[550px] h-full w-full p-0">
          <div className="flex flex-grow h-full">
            <div className="w-full border-r border-neutral-800/50">
              <ConnectWalletSection
                onModalOpens={() => setShouldCloseOnInteractOutside(false)}
                onModalCloses={() => setShouldCloseOnInteractOutside(true)}
              />
            </div>
            <div className="w-full hidden md:block">
              <ProductShowcase />
            </div>
          </div>
        </ModalContent>
      </Modal>
    </div>
  );
}
